/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type PointsFigureAxis = (typeof PointsFigureAxis)[keyof typeof PointsFigureAxis];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsFigureAxis = {
  week: 'week',
  attempt: 'attempt',
  sessionWeek: 'sessionWeek',
} as const;
